var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3",domProps:{"innerHTML":_vm._s(_vm.$t('common:terms', { url: 'https:\/\/www.vivawallet.com/terms-and-conditions' }))}})}
var staticRenderFns = []

export { render, staticRenderFns }